
import React from "react";
import { 
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from "@/components/ui/dialog";
import { Screen } from "@/models/screen";
import { Ad } from "@/models/ad";
import AdMaterialEditForm from "./form/AdMaterialEditForm";

interface EditAdDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (data: any) => void;
  availableScreens: Screen[];
  selectedAd: Ad | null;
}

const EditAdDialog: React.FC<EditAdDialogProps> = ({
  isOpen,
  onOpenChange,
  onSubmit,
  availableScreens,
  selectedAd
}) => {
  if (!selectedAd) return null;
  
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px] w-[90vw]">
        <DialogHeader>
          <DialogTitle>Editar Material del Anuncio</DialogTitle>
          <DialogDescription>
            Agrega o actualiza el enlace al material del anuncio
          </DialogDescription>
        </DialogHeader>
        <AdMaterialEditForm 
          onSubmit={onSubmit}
          onCancel={() => onOpenChange(false)}
          initialMaterialUrl={selectedAd.materialUrl || ""}
        />
      </DialogContent>
    </Dialog>
  );
};

export default EditAdDialog;
